import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-academic-integrity',
  templateUrl: './academic-integrity.component.html',
  styleUrls: ['./academic-integrity.component.scss'],
  standalone: false,
})
export class AcademicIntegrityComponent {
  @Input() title = "Academic integrity isn't optional—it's essential.";
  @Input() subtitle = 'Achieve + Respondus Integration, Now Available';
  @Input() description =
    'Strong assessments, now with more security. Pair quality assessments with the peace of mind of enhanced exam security.';
  @Input() ctaText = 'Try Achieve with Respondus';
  @Input() ctaLink =
    'https://go.macmillanlearning.com/achieveaccessrequest.html?utm_source=Microsite&utm_medium=Respondus&utm_content=tryachievewithrespondus&utm_id=119600&utm_campaign=MH-AchieveRetention2501';
  @Input() videoEmbedUrl =
    'https://www.youtube.com/embed/dQw4w9WgXcQ?rel=0&modestbranding=1&controls=1&showinfo=0';
  @Input() videoTitle = 'How to Use Respondus in Achieve | Secure Online Testing Made Simple';
  @Input() placeholderImage =
    'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&auto=format&fit=crop&w=560&h=315&q=80';
  @Input() showFallback = false;
}
